import { FC, MouseEvent, ReactNode } from "react";
import styles from "./DrawButton.module.scss";
import { getKeyByValue } from "../../../utils/enums";
import { DrawState } from "../DrawCard";
import { ActionPromptType } from "../../../hooks/prompts";
import { Highlightable } from "../../Highlight/Highlightable";
import { IBalances } from "../../../types/balances";
import { Ticket, TicketType } from "../../TicketsPanel/Ticket";
import { ITicketsBalances } from "../../../model/user-info.interface";
import { DrawType } from "../../../pages/DrawPage/DrawItem";

interface IDrawButtonProps {
    caption?: ReactNode;
    amount: number;
    cost?: IBalances;
    drawState: DrawState;
    type: DrawType;
    handler: (event: MouseEvent<HTMLButtonElement>) => void;    
}

export const DrawButton: FC<IDrawButtonProps> = ({ caption, amount, cost, drawState, type, handler }) => {
    const getCost = (cost: ITicketsBalances) => {
        const currency: TicketType = Object.keys(cost)[0] as TicketType;

        return (
            <span className={styles.buyPrice}>
                <Ticket type={ currency } value={ amount * cost[currency] } context="draw-button" precission={ 0 } />
            </span>
        )
    }

    const getButtonClass = () => drawState === DrawState.Confirm ? styles.confirm : styles[getKeyByValue(DrawType, type)];

    return (
        <Highlightable promptType={ActionPromptType.JOIN_DRAW_FIRST_TIME} highlightClass={styles.highlight} >
            <button
                className={ `${styles.btn} ${getButtonClass()}` }
                onClick={ (event) => handler(event) }
            >
                { caption }
                { cost && getCost(cost) }
            </button>
        </Highlightable>
    );
}